import firebase from 'firebase'

const firebaseConfig = {
  apiKey: 'AIzaSyBhg_hS2sk0AuG5HBUP09n0iH_pUARSSFU',
  authDomain: 'freemind-71892.firebaseapp.com',
  databaseURL: 'https://freemind-71892.firebaseio.com',
  projectId: 'freemind-71892',
  storageBucket: 'freemind-71892.appspot.com',
  messagingSenderId: '303860959262',
  appId: '1:303860959262:web:462f14a80697796020860f'
}

const firebaseApp = firebase.initializeApp(firebaseConfig)
const firestore = firebaseApp.firestore()
const firebaseAuth = firebaseApp.auth()
const firebaseStorage = firebaseApp.storage()

export { firebaseApp, firestore, firebaseAuth, firebaseStorage }
